
import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-toolbar2";
import GenericListTab from "./../../factories/generic-list-tab";
import Shiftbook from "../shiftbook";
import BaoDialog from "./../../factories/bao-dialog";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import baoRouter from "./../../services/bao-router";
import * as moment from "moment";

/*
 * View model for a list displaying shift patterns assignment to the shiftbook
 * */
class ShiftbookShiftPlanModel extends GenericListTab {
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.SaveAllowed = parent.SaveAllowed;
        this.Models.subscribe(() => {
            this.Selection([]);
        });
    }

    DateTimeWithOffset: KnockoutObservable<string> = ko.observable("");
    AppendHoursModel: KnockoutObservableArray<{ Key: number, Value: string }> = ko.observableArray([]);

    PageSize = ko.observable(0);

    SaveAllowed: KnockoutObservable<boolean>;

    ControllerUrl = "ShiftbookShiftPlanModel";

    CustomFilter(): Models.HashObject[] {
        return null;
    }

    init(): JQueryPromise<void> {
        return super.init().then(_ => {
            return Bao.post('ShiftbookShiftPlanModel/GetDateTimeToCompare').then((result) => {
                this.DateTimeWithOffset(result.DateTimeWithOffset);
            });
        }).then(_ => {
            return Bao.post('ShiftbookShiftPlanModel/GetAppendHoursDictionary').then((result) => {
                this.AppendHoursModel(result.Model);
            });
        }).always(() => {
            this.TabPage.IsLoading(false);
        });
    }

    ToggleToolbarButtons() {
        ko.utils.arrayForEach(this.ToolbarButtons(), (button) => {
            let key = ko.unwrap(button.ActionKey);
            let enabled = <KnockoutObservable<boolean>>(button.Enabled);

            if (key === this.PermissionEdit) {
                // only allow editing of new and future ShiftbookShiftPlanModel
                enabled(this.Selection() !== null
                    && this.Selection().length == 1
                    && (this.Selection()[0].IsNew
                    || this.Selection()[0].StartDateJs > this.DateTimeWithOffset()
                    )
                );
            } else if (key === this.PermissionRemove) {
                //only allow deletions of new or future ShiftbookShiftPlanModel that have not started
                enabled(this.Selection() !== null
                    && this.Selection().length > 0
                    && this.Selection().filter(x => !x.IsNew && x.StartDateJs < this.DateTimeWithOffset()).length === 0
                );
            }
        });
    }

    BeforeRemove(itemIds: string[]): JQueryPromise<boolean> {
        const result = this.Models().filter(item => {
            const element = <any>item;
            if (element.StartDateJs < this.DateTimeWithOffset() && !element.IsNew && itemIds.indexOf(item.PrimaryKeyValue) >= 0) {
                return true;
            }
            return false;
        }
        );

        if (result.length > 0) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgShiftPatternIsUsed"), "info");
            return $.Deferred<boolean>().resolve(false).promise();
        }
        else {
            return super.BeforeRemove(itemIds);
        }

    }

    ItemCompleteCheck(): JQueryPromise<boolean> {
        let def = $.Deferred<boolean>();
        def.resolve(true);
        return def.promise();
    }

    public Edit(item) {
        if (item != null) {
            this.Dialog(ko.unwrap(item.PrimaryKeyValue));
        }
    }

    CompleteCheck(): JQueryPromise<boolean> {
        this.TabPage.IsLoading(true);
        return Bao.post('ShiftbookShiftPlanModel/Validate', JSON.stringify({ sessionTabId: this.SessionTabId, parentId: this.GetParentId() })).then((result) => {
            if (!result.Result) {
                if (!result.Message) {
                    Bao.Session.GetMessage("msgNextShiftPatternForShiftbook").then((message) => {
                        new BaoDialog(Bao.Session.ApplicationName, message.replace('{0}', moment.duration(result.MaxAllowed, "minutes").humanize()), "info");
                    });
                } else {
                    new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
                }
                return false;
            } 
            else if (result.Result && (result.QuestionDeleteExistsReports || result.IsNewOrChanged)) {
                return this.DialogDeleteReports(result.QuestionDeleteExistsReports, result.ShiftPatternInformationMessage);
            }

            return true;
        })
            .always(() => {
                this.TabPage.IsLoading(false);
            });
    }

    link(index: number, model) {
        let linkHash = 'shiftplanmodel/' + model.ShiftPlanModelId;
        baoRouter.setHash(linkHash);
    }

    /*
     *  Returns a text value for the selected AppendHours.
     * */
    GetValueAppedHours(index: any): string {
        if (index >= 0) {
            return this.AppendHoursModel().filter(x => x.Key === index)[0].Value;
        }
        return "";
    }

    /*
     * Shows a dialog where the user has to confirm that they want to delete reports from the future.
     * */
    DialogDeleteReports(questionDeleteExistsReports: boolean, shiftPatternInformationMessage: string): JQueryPromise<boolean> {
        this.TabPage.IsLoading(true);
        let def = $.Deferred<boolean>();
        Bao.post("ShiftbookShiftPlanModel/DeleteExistsReportsDialog", JSON.stringify({}), ((result) => {

            let deleteDialog = new BaoDialog(Bao.Session.ApplicationName);
            deleteDialog.Open();
            deleteDialog.ViewModel({
                Bao: Bao,
                CaptionValue: ko.observable(Bao.Session.GetMessage('msgDeleteExistsReports')),
                CaptionInfo: ko.observable(shiftPatternInformationMessage),
                InputValue: ko.observable(''),
                QuestionDeleteExistsReports: ko.observable(questionDeleteExistsReports)
            });
            deleteDialog.Buttons([new BaoDialog.ButtonFactory(deleteDialog, Bao.Session.GetMessage("msgOk"), () => {
                const inputValueText = deleteDialog.ViewModel().InputValue();
                if (deleteDialog.ViewModel().QuestionDeleteExistsReports()) {
                    if (inputValueText === 'delete') {
                        (<Shiftbook>this.Parent).DeleteNextReports(true);
                        deleteDialog.DialogResult(true);
                        deleteDialog.Close();
                    }
                    else {
                        new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgDeleteExistsReportsInputMessage"), "info");
                    }
                }
                else {
                    deleteDialog.DialogResult(true);
                    deleteDialog.Close();
                }
            }),
            new BaoDialog.ButtonFactory(deleteDialog, Bao.Session.GetMessage("msgCancel"), () => {
                deleteDialog.DialogResult(false);
                deleteDialog.Close();
            })
            ]);
            deleteDialog.Width("600px");
            deleteDialog.Template(result);
            this.Subscribe(deleteDialog.DialogResult, (dialogResult: boolean) => {
                def.resolve(dialogResult);
            });
        }))
        .always(_ => this.TabPage.IsLoading(false));
       
        return def.promise();
    }
}
export default ShiftbookShiftPlanModel;